"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_sonner_1 = require("vue-sonner");
require("vue-sonner/style.css");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Toast',
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(vue_sonner_1.Toaster), {
                position: "top-center",
                "close-button": "",
                "close-button-position": "top-right",
                duration: 1000,
                "toast-options": {
                    classes: {
                        toast: 'oplus-toast',
                        title: 'oplus-toast-title',
                        description: 'oplus-toast-description',
                        icon: 'oplus-toast-icon',
                        closeButton: 'oplus-toast-close',
                        success: 'oplus-toast-success',
                        error: 'oplus-toast-error',
                        info: 'oplus-toast-info',
                    },
                }
            }));
        };
    }
});
